import { MessageBar, Text } from "@bps/fluent-ui";
import { ContactFetcher } from "@ui-components/ContactFetcher.tsx";

import { ContactMethodListAddresses } from "../view/contact-method-list/ContactMethodListAddresses.tsx";
import { ContactMethodListCommunications } from "../view/contact-method-list/ContactMethodListCommunications.tsx";

type EmployerInfoCardProps = {
  selectedOrgId?: string;
};

export const EmployerInfoCard: React.FC<EmployerInfoCardProps> = ({
  selectedOrgId
}) => {
  if (!selectedOrgId) return null;
  return (
    <ContactFetcher contactId={selectedOrgId}>
      {contact =>
        contact.addresses.length > 0 || contact.communications.length > 0 ? (
          <MessageBar>
            <Text>The following contact methods will be added</Text>
            <ContactMethodListCommunications
              isOrganisation={true}
              contact={contact}
              asBullet
            />
            <ContactMethodListAddresses contact={contact} asBullet />
          </MessageBar>
        ) : (
          <MessageBar>{`No contact methods for ${contact.name}, but they will propagate here if added to ${contact.name}`}</MessageBar>
        )
      }
    </ContactFetcher>
  );
};
